import { CustomAttributeConfigurationQueryParam, ICustomAttributeConfiguration, queryKeys } from '../../shared';
import { useDelete, useSave } from '../../shared/hooks/new-base.hook';
import { customAttributeConfigurationClient } from '../clients/custom-attribute-configuration.client';
import { useItem, UseItemParams, useList, UseListParams } from '../../shared/hooks/new-read-only.hook';

const client = customAttributeConfigurationClient;
const listKey = queryKeys.CUSTOM_ATTRIBUTE_CONFIGURATIONS;
const itemKey = queryKeys.CUSTOM_ATTRIBUTE_CONFIGURATION;

export function useCustomAttributeConfigurationList(
    ...args: UseListParams<ICustomAttributeConfiguration, CustomAttributeConfigurationQueryParam>
) {
    return useList(client, listKey, args);
}

export function useCustomAttributeConfiguration(...args: UseItemParams<ICustomAttributeConfiguration>) {
    return useItem(client, itemKey, args);
}

export function useSaveCustomAttributeConfiguration() {
    return useSave(client, listKey, itemKey);
}

export function useDeleteCustomAttributeConfiguration() {
    return useDelete(client, listKey);
}
